export const ITEM_SELECTOR = `[combobox-item=""]`
export const VALID_ITEM_SELECTOR = `${ITEM_SELECTOR}:not([aria-disabled="true"])`
export const VALUE_ATTR = `data-value`
export const PICK_EVENT = `combobox-item-select`
